export { FileInbox as default } from "./file-inbox";
